module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-graph-c7d69e20631e1e11639bc8e3bed1d5a9.svg";